import * as React from 'react';

import * as style from './GKCardButtonsLayout.css';

export const GKCardButtonsLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={style['buttons-layout']} data-testid="actionButtons">
      {children}
    </div>
  );
};
